module.exports = __webpack_public_path__ + "static/media/ShopOnBudget4.27a1f607.png";